import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar } from './ui/Kit';

const ROLE_LABEL = { company_super_admin: 'Company admin', company_user: 'Team member', master_admin: 'Master admin' };

export function logout(navigate) {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('company');
  navigate('/');
}

// The profile menu in every header (AppShell pages and both dashboards). Company admin: Organization · Subscription ·
// Settings · Logout; everyone else: Settings · Logout. Subscription opens the plans modal — it lives on the admin
// dashboard, so outside it the menu goes there (?menu=subscription) and the dashboard opens it.
export default function ProfileMenu({ user, onSubscription }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const outside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', outside);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', outside); document.removeEventListener('keydown', esc); };
  }, [open]);
  const u = user || {};
  const admin = u.role === 'company_super_admin';
  const go = (fn) => () => { setOpen(false); fn(); };
  const items = [
    ...(admin ? [['Organization', go(() => navigate('/organization'))],
      ['Subscription', go(() => (onSubscription ? onSubscription() : navigate('/dashboard/company-admin?menu=subscription')))]] : []),
    ['Settings', go(() => navigate('/settings'))],
  ];
  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => setOpen(!open)} aria-haspopup="menu" aria-expanded={open} aria-label="Profile menu"
        className="flex items-center gap-2.5 rounded-lg px-2 py-1 hover:bg-[#F5F7FB]">
        <Avatar name={u.full_name} />
        <span className="leading-tight text-left">
          <span className="block text-sm font-bold text-[#0F172A]">{u.full_name}</span>
          <span className="block text-xs text-[#64748B]">{ROLE_LABEL[u.role] || ''}</span>
        </span>
        <svg aria-hidden="true" className={`w-4 h-4 text-[#94A3B8] transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
      </button>
      {open && (
        <div role="menu" className="absolute right-0 mt-2 w-52 bg-white rounded-xl shadow-2xl border border-[#E6E9F0] py-1.5 z-50">
          {items.map(([label, fn]) => (
            <button key={label} role="menuitem" type="button" onClick={fn} className="w-full text-left px-4 py-2.5 text-sm font-semibold text-[#334155] hover:bg-[#F5F7FB]">{label}</button>
          ))}
          <div className="border-t border-[#E6E9F0] my-1.5" />
          <button role="menuitem" type="button" onClick={go(() => logout(navigate))} className="w-full text-left px-4 py-2.5 text-sm font-semibold text-[#B91C1C] hover:bg-red-50">Logout</button>
        </div>
      )}
    </div>
  );
}
